
import SummarySectionHeading from 'parts/SummarySectionHeading';
import TextSection from 'parts/TextSection';
import Cinedapt from './Cinedapt';

const CinedaptSection = ({
  className,
  type,
  data,
  baseUrl
}) => (
  <>
    <div className={className}>
      <TextSection
        //className='streaming-section-bottom-margin'
        heading={type}
        text={data} />
      <div style={{marginTop:'5px'}}></div>
      <Cinedapt
        data={data}
        baseUrl={baseUrl} />
    </div>
  </>
);

export default CinedaptSection;
